/* eslint-disable */
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/Components/ui/tabs'
import { Card, DatePicker, DateRangePicker, Message, useToaster } from 'rsuite'
import { useShallow } from 'zustand/react/shallow'
import { Button } from '@/Components/ui/button'
import {
    Check,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    Filter,
    ClipboardList,
    CheckCircle,
    AlertCircle,
    RotateCcw,
    Search,
    X,
    Plus,
} from 'lucide-react'
import { Popover, PopoverContent, PopoverTrigger } from '@/Components/ui/popover'
import { Input } from '@/Components/ui/input'
import { Checkbox } from '@/Components/ui/checkbox'
import { cn } from '@/lib/utils'
import { Bar, Line } from 'react-chartjs-2'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    LineElement,
    PointElement,
    Filler
} from 'chart.js'
import { TimeFilter } from '../TimeFilter'
import { groupTypeFilterList, useTimeFilter } from '@/Helpers'
import ModernTabs from './Components/ModernTabs'
import DateSwitcher from './Components/DateSwitcher'
import MetricCard from './Components/MetricsCard'
import MetricsGrid from './Components/MetricsGrid'
import { connect } from 'react-redux'
import { analyticsAction, formActions } from '@/Actions'
import ParameterSelector from './Components/ParameterSelector'
import { motion, AnimatePresence } from 'framer-motion'

import { defaultFailureParameters, defaultFailureChartData, DISCRETE_TIME_FILTERS, defaultProducts } from './Components/data'
import analyticsTypeConstant from '@/Constants/analyticsType.contants'
import { configQuality } from './Components/configQuality'
import { getDate, getWeekOfMonth } from 'date-fns'
import { timeFilterMap } from '@/Constants'
import qualityAnalyticsServices from '@/Services/Analytics Services/qualityAnalytics.services'
import { deserializeFilters } from '@/Actions/analytics.actions'
import { notificationServices } from '@/Services'
import moment from 'moment'
import masterMenuServices from '@/Services/ProductSpecificationParamServices/productMasterMenu.services'
import { cloneDeep } from 'lodash'
import { STAT_COLORS } from '@/Styles/colors'
import { LineChart } from '../Analytics'
import StatisticalChart from './Components/StatisticalChart'

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    LineElement,
    PointElement,
    Filler
)

//CONSTANTS-CONSTANTS-CONSTANTS-CONSTANTS-CONSTANTS
const todayDate = new Date();
const timeFrameList = ['Daily', 'Week', 'Month', 'Custom'];

const QualityAnalysisTabs = [
    { value: 'overall', label: 'Overall View' },
    { value: 'machine', label: 'AI Supervisor checks' },
    { value: 'app', label: 'App Checklist' },
]

const tabVariants = {
    enter: {
        opacity: 0,
        y: 20
    },
    center: {
        opacity: 1,
        y: 0
    },
    exit: {
        opacity: 0,
        y: -20
    }
};

const fadeVariants = {
    hidden: {
        opacity: 0,
        y: 10
    },
    visible: {
        opacity: 1,
        y: 0
    }
};

const GROUP_TYPE_FILTER = {
    active: true,
    type: 'periodWise',
    currentSelection: 'brand',
    selection: {
        brand: {
            value: null,
            label: 'Brand',
        },
        category: {
            value: null,
            label: 'Category',
        },
        subCategory: {
            value: null,
            label: 'Sub Category',
        },
    },
};

//CONSTANTS-CONSTANTS-CONSTANTS-CONSTANTS-CONSTANTS
function QualityAnalysisDashboard({
    initialTab = 'quality',
    date = new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }),
    failureChartData = defaultFailureChartData,
    onSubTabChange,
    onFilterChange,
    onDateChange,
    onFilterButtonClick,
    brandsList,
    // GROUP_TYPE_FILTER,
    DATE_FILTER_TODAY_DATE,
    DATE_RANGE_FILTER,
    GEO_FILTER,
    BRAND_FILTER,
    STORE_FILTER,
    FAILURE_ANALYSIS_FILTER,
    PRODUCT_FILTER,
    // setGroupTypeFilter,
    setDateFilter,
    setDateRangeFilter,
    applyFilters,
    fetchBrands,
    fetchProducts,
    products = [],
}) {

    const [data, setData] = useState([]);
    const [boxData, setBoxData] = useState([]);
    const [statsBoxData, setStatsBoxData] = useState([]);
    const [chart, setChartData] = useState({
        labels: [],
        datasets: [],
        labelIds: []
    });
    const [activeTab, setActiveTab] = useState(initialTab);
    const [activeSubTab, setActiveSubTab] = useState('overall');
    const [activeFilter, setActiveFilter] = useState('periodWise');
    const [currentDate, setCurrentDate] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedProduct, setSelectedProduct] = useState('');
    const [showProductSelection, setShowProductSelection] = useState(true);
    const [lineData, setLineData] = useState({});
    const [cardData, setCardData] = useState([]);
    const [metricData, setMetricData] = useState([]);
    const [isCollapsed, setIsCollapsed] = useState([]);
    // const { setTimeFilter, timeFilters } = useTimeFilter({
    //     DISCRETE_TIME_FILTERS,
    //     applyFilters: () => { },
    // });
    const [groupTypeFilter, setGroupTypeFilter] = useState(GROUP_TYPE_FILTER);
    const [parameters, setParameters] = useState([]);
    const [qualityValue, setQualityValue] = useState(null);
    const [timeFrame, setTimeFrame] = useState('Daily');
    const [timeValue, setTimeValue] = useState(null);
    // Add this new state to track if we're at today's date
    const [isCurrentDate, setIsCurrentDate] = useState(
        new Date(date).toDateString() === new Date().toDateString()
    )
    const [timeFilters, setTimeFilter] = useState(() => {
        const newFilter = cloneDeep(DATE_FILTER_TODAY_DATE);
        return DISCRETE_TIME_FILTERS.map((tfilter) => {
            let active = false;
            let text = '';

            if (tfilter?.type === 'month') {
                newFilter.selection.month = timeFilterMap.month[todayDate.getUTCMonth()];
                text = newFilter?.selection?.[tfilter.type] || tfilter.text;
            } else {
                text = newFilter?.selection?.[tfilter.type] || tfilter.text;
            }

            if (newFilter?.type === 'day' && tfilter?.type === 'week') {
                return {
                    ...tfilter,
                    active: true,
                    text,
                };
            }

            active = tfilter?.type === newFilter?.type;

            if (active) {
                return {
                    active: newFilter?.active,
                    text: newFilter?.text,
                    type: newFilter?.type,
                };
            }

            return {
                ...tfilter,
                active: false,
                text,
            };
        });
    });
    const [timeActive, setTimeActive] = useState(() => {
        const currentTimeType = timeFilters.find((filter) => filter.active) || null;
        return currentTimeType?.type || null;
    });
    const [parameterProducts, setParameterProducts] = useState([]);
    const timeType = useMemo(() => {
        const currentTimeType = timeFilters.find((filter) => filter.active) || null;
        setTimeActive(currentTimeType?.type);
    }, [timeFilters]);
    // add loading state
    const [isLoading, setIsLoading] = useState(false);
    const [statisticalFilter, setStatisticalFilter] = useState({});


    useEffect(() => {
        if (activeTab === 'statisticalAnalysis') {
            const defaultValue = {
                name: 'pH',
                id: 4,
                selected: true,
            };
            setQualityValue(defaultValue);

            // Update statistical filter with default value
            setStatisticalFilter({
                ...statisticalFilter,
                qualityParameterId: defaultValue.id,
            });
            fetchParameterProductsStatisticalAnalysis(defaultValue?.id);
        } else {
            setQualityValue(null);
        }
    }, [activeTab]); // Dependencies array


    // fetching the data
    const fetchBarData = async (tabType = null, subTabType = null) => {
        const filters = deserializeFilters({
            GROUP_TYPE_FILTER: groupTypeFilter,
            DATE_FILTER_TODAY_DATE,
            DATE_RANGE_FILTER,
            GEO_FILTER,
            BRAND_FILTER,
            STORE_FILTER,
            FAILURE_ANALYSIS_FILTER,
            PRODUCT_FILTER,
        });
        const req = {
            data: {
                ...filters,
                dateFilter: {
                    ...filters?.dateFilter,
                    month: filters?.dateFilter?.month ? filters?.dateFilter?.month : new Date().getUTCMonth() + 1,
                },
                tabType: tabType ?? activeTab,
                subTabType: tabType === 'failureAnalysis' ? null : subTabType ?? activeSubTab,
            }
        }
        try {
            const response = await qualityAnalyticsServices.fetchQualityAnalysisChartData({ req });
            if (response?.statusCode === 200) {
                setData(response?.data);
            } else {
                notificationServices.generateNotification({
                    type: 'error',
                    message: response?.message || 'Error fetching bar data',
                });
            }
        } catch (error) {
            notificationServices.generateNotification({
                type: 'error',
                message: error?.toString() || 'Error fetching bar data',
            });
        }
    };

    useEffect(() => {
        if (brandsList?.length > 0) {
            const brand = {
                brand: {
                    value: brandsList[0]?.id,
                    label: brandsList[0]?.name,
                },
            };

            setGroupTypeFilter({
                active: true,
                type: 'periodWise',
                currentSelection: 'brand',
                selection: {
                    ...brand
                },
            });

            setDateFilter({
                ...DATE_FILTER_TODAY_DATE,
                selection: {
                    ...DATE_FILTER_TODAY_DATE.selection,
                    month: timeFilterMap.month[todayDate.getUTCMonth()],
                },
            });
        }
    }, [brandsList]);

    // fetching params 
    const fetchList = async () => {
        try {
            const response = await masterMenuServices.productMasterMenuList();
            if (response?.statusCode === 200) {
                const data = response?.data;
                const newData = data.map(item => ({
                    id: item?.id,
                    name: item?.name,
                    inputType: item?.inputType,
                }));
                setParameters(newData);
            }
        } catch (error) {

        }
    };

    useEffect(() => {
        fetchBrands({
            entity: 'BRANDS',
            req: {
                params: {
                    id: '',
                },
            },
            method: 'LIST',
        });
        fetchList();
        fetchProducts({
            entity: 'ALL_PRODUCTS',
            req: {
                params: {
                    id: '',
                    variants: true,
                    skuType: '',
                    combo: true,
                },
            },
            method: 'LIST',
        });
    }, []);

    useEffect(() => {
        // if (!firstRender.current && filtersReady.groupFilter && filtersReady.dateFilter) {
        if (activeTab !== 'statisticalAnalysis') {
            if (groupTypeFilter?.active) {
                fetchBarData();
            }
        }
    }, [groupTypeFilter, DATE_FILTER_TODAY_DATE, DATE_RANGE_FILTER, GEO_FILTER, BRAND_FILTER, STORE_FILTER, FAILURE_ANALYSIS_FILTER, PRODUCT_FILTER]);

    useEffect(() => {
        if (data?.statsData) {
            setBoxData(configQuality.boxSerilizer(data?.statsData) || []);

            const chartData = data?.chartData || {
                labels: [],
                dataset: [],
                labelIds: []
            };

            setChartData({
                labels: chartData.labels || [],
                datasets: chartData.dataset || [],
                labelIds: chartData.labelIds || []
            });
        }
    }, [data])

    const fetchStatisticalAnalysis = async (selectedProduct = null, addedCardData = []) => {
        const filters = {
            ...statisticalFilter,
            productIds: [selectedProduct],
            qualityParameterId: qualityValue?.id,
        };
        const groupDateRanges = {};

        addedCardData.forEach((item, index) => {
            if (index < addedCardData.length) {
                const key = item?.id;
                if (Array.isArray(item?.timeFrame?.value)) {
                    groupDateRanges[key] = {
                        "start": moment(item?.timeFrame?.value[0]).format('YYYY-MM-DD'),
                        "end": moment(item?.timeFrame?.value[1]).format('YYYY-MM-DD')
                    };
                } else if (typeof item?.timeFrame?.value === 'object') {
                    groupDateRanges[key] = {
                        "start": moment(item?.timeFrame?.value).format('YYYY-MM-DD'),
                        "end": moment(item?.timeFrame?.value).format('YYYY-MM-DD')
                    };
                }
            }
        });
        const req = {
            data: {
                statisticalFilter: filters,
                groupDateRanges: groupDateRanges,
                tabType: activeTab,
                subTabType: null,
            }
        }
        try {
            setIsLoading(true);
            const response = await qualityAnalyticsServices.fetchQualityAnalysisChartData({ req });
            if (response?.statusCode === 200) {
                const { data } = response;
                setStatsBoxData(configQuality.statsSerilizer(data?.boxData) || []);
                setLineData(data?.graphData);
                setMetricData(data?.metrics);
                statisticalAnalysisCardData(data?.metrics);
                setIsLoading(false);
            } else {
                notificationServices.generateNotification({
                    type: 'error',
                    message: response?.message || 'Error fetching bar data',
                });
            }
        } catch (error) {
            notificationServices.generateNotification({
                type: 'error',
                message: error?.toString() || 'Error fetching bar data',
            });
        }
    };

    const fetchParameterProductsStatisticalAnalysis = async (value = '') => {
        const req = {
            data: {
                qualityParameterId: value,
            }
        }
        try {
            const response = await qualityAnalyticsServices.fetchParameterProductsStatisticalAnalysis({ req });
            if (response?.statusCode === 200) {
                setParameterProducts(response?.data?.productIds);
            } else {
                notificationServices.generateNotification({
                    type: 'error',
                    message: response?.message || 'Error fetching bar data',
                });
            }
        } catch (error) {
            console.log(error, 'error');
        }
    };

    const handleTabChange = (value) => {
        setActiveTab(value);
        if (value !== 'statisticalAnalysis') {
            fetchBarData(value);
        }
    }

    const handleSubTabChange = (value) => {
        setActiveSubTab(value);
        fetchBarData(activeTab, value);
    }
    // handleProdcutSelection
    const handleProductSelection = (value) => {
        setSelectedProduct(value);
        if (cardData.length > 0) {
            handleUpdateCardData(value);
        }
    }
    const handleUpdateCardData = (value) => {
        const productName = filteredProducts.find(p => Number(p.id) === Number(value))?.productName || 'Unknown Product';
        const newCardData = cardData.map(item => {
            return {
                ...item,
                name: productName,
                id: item.id,
                timeFrame: item.timeFrame,
                borderColor: item.borderColor,
                cp: '',
                cpk: ''
            }
        });
        setCardData(newCardData);
        fetchStatisticalAnalysis(value, newCardData);
    }
    const handleFilterChange = (value) => {
        setActiveFilter(value);
        const typeFilterData = groupTypeFilterList?.find((ele) => {
            return ele?.value === value;
        });

        const brand = {
            brand: {
                value: brandsList?.[0]?.id,
                label: brandsList?.[0]?.name,
            },
        };
        if (typeFilterData.value === 'periodWise') {
            // setDateRangeFilter({
            //     ...DATE_RANGE_FILTER,
            //     active: false,
            // });
        } else {
            // setDateRangeFilter({
            //     ...DATE_RANGE_FILTER,
            //     active: true,
            // });
        }
        const selection = {
            ...brand,
            ...typeFilterData?.selection,
        };
        setGroupTypeFilter({
            active: true,
            type: typeFilterData?.value,
            currentSelection: typeFilterData?.currentSelection,
            selection: selection || {},
        });
    };
    const handleTypeFilter = (type) => {
        setGroupTypeFilter(prev => ({
            ...prev,
            currentSelection: type,
            selection: {
                ...prev.selection,
                [type]: prev.selection[type]
            }
        }));
    };

    const handleTimeFilter = (
        type,
        selection = {
            year: new Date().getFullYear(),
            month: timeFilterMap.month[new Date().getUTCMonth()],
            day: getDate(new Date()),
            hour: null,
            week: getWeekOfMonth(new Date()),
        }
    ) => {
        const clonedSelection = cloneDeep(selection);
        let selectedFilter = null;
        let overrideText = false;
        const newTimeFilters = timeFilters.map((tfilter, idx) => {
            const active = type === tfilter.type;
            let text =
                (!overrideText && selection[tfilter.type]) ||
                DISCRETE_TIME_FILTERS[idx].text;

            if (
                tfilter.type === 'month' &&
                typeof selection[tfilter.type] === 'number'
            ) {
                const monthNumber = selection[tfilter.type] - 1;
                text = timeFilterMap.month[monthNumber];
            }

            clonedSelection[tfilter.type] = !overrideText
                ? selection[tfilter.type]
                : null;

            const newFilter = {
                ...tfilter,
                active,
                text,
            };

            if (active) {
                overrideText = true;
                selectedFilter = {
                    ...newFilter,
                    selection: clonedSelection,
                };
            }
            return newFilter;
        });
        setTimeFilter(newTimeFilters);

        // type == hour
        // type == week
        if (!selectedFilter) {
            selectedFilter = {
                text: selection.day,
                type: 'day',
                active: true,
                selection: clonedSelection,
            };
        }
        setDateFilter(selectedFilter);
    };

    useEffect(() => {
        if (cardData?.length > 0) {
            const updatedCardData = cardData.map((item) => {
                let updatedTimeFrame = {};

                // Get new default values based on timeFrame type
                const getDefaultValue = () => {
                    switch (timeFrame) {
                        case 'Daily':
                        case 'Year':
                            return new Date();
                        case 'Week':
                            return [
                                new Date(new Date().setDate(new Date().getDate() - new Date().getDay())),
                                new Date(new Date().setDate(new Date().getDate() - new Date().getDay() + 6))
                            ];
                        case 'Month':
                            return [
                                new Date(new Date().setDate(1)),
                                new Date(new Date().setMonth(new Date().getMonth() + 1, 0))
                            ];
                        case 'Custom':
                            return [new Date(), new Date()];
                        default:
                            return new Date();
                    }
                };

                switch (timeFrame) {
                    case 'Daily':
                        updatedTimeFrame = {
                            timeType: 'daily',
                            value: timeFrame === item.timeFrame.timeType ? item.timeFrame.value : getDefaultValue(),
                            component: <DatePicker
                                format="yyyy-MM-dd"
                                value={timeFrame === item.timeFrame.timeType ? item.timeFrame.value : getDefaultValue()}
                                defaultOpen={true}
                            />
                        };
                        break;

                    case 'Week':
                        updatedTimeFrame = {
                            timeType: 'weekly',
                            value: timeFrame === item.timeFrame.timeType ? item.timeFrame.value : getDefaultValue(),
                            component: <DateRangePicker
                                format="yyyy-MM-dd"
                                hoverRange="week"
                                style={{ width: '100%' }}
                                value={timeFrame === item.timeFrame.timeType ? item.timeFrame.value : getDefaultValue()}
                                defaultOpen={true}
                            />
                        };
                        break;

                    case 'Month':
                        updatedTimeFrame = {
                            timeType: 'monthly',
                            value: timeFrame === item.timeFrame.timeType ? item.timeFrame.value : getDefaultValue(),
                            component: <DateRangePicker
                                hoverRange="month"
                                ranges={[]}
                                style={{ width: '100%' }}
                                value={timeFrame === item.timeFrame.timeType ? item.timeFrame.value : getDefaultValue()}
                                defaultOpen={true}
                            />
                        };
                        break;

                    case 'Year':
                        updatedTimeFrame = {
                            timeType: 'yearly',
                            value: timeFrame === item.timeFrame.timeType ? item.timeFrame.value : getDefaultValue(),
                            component: <DatePicker
                                hoverRange="year"
                                ranges={[]}
                                style={{ width: '100%' }}
                                value={timeFrame === item.timeFrame.timeType ? item.timeFrame.value : getDefaultValue()}
                                defaultOpen={true}
                            />
                        };
                        break;

                    case 'Custom':
                        updatedTimeFrame = {
                            timeType: 'custom',
                            value: timeFrame === item.timeFrame.timeType ? item.timeFrame.value : getDefaultValue(),
                            component: <DateRangePicker
                                style={{ width: '100%' }}
                                value={timeFrame === item.timeFrame.timeType ? item.timeFrame.value : getDefaultValue()}
                                defaultOpen={true}
                            />
                        };
                        break;

                    default:
                        break;
                }

                return {
                    ...item,
                    timeFrame: updatedTimeFrame
                };
            });

            setCardData(updatedCardData);
        }
    }, [timeFrame]);

    const handleAddTimeFrame = () => {
        if (!selectedProduct) {
            notificationServices.generateNotification({
                type: 'info',
                message: 'Please select at least one product',
            });
            return;
        }
        const newId = cardData.length > 0
            ? Math.max(...cardData.map(item => item.id)) + 1
            : 1;

        const borderColors = ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40', '#8AC926', '#1982C4'];
        const newCardData = [];
        const productName = filteredProducts.find(p => Number(p.id) === Number(selectedProduct))?.productName || 'Unknown Product';
        const borderColorIndex = cardData.length % borderColors.length;
        const borderColor = borderColors[borderColorIndex];

        switch (timeFrame) {
            case 'Daily': {
                newCardData.push({
                    id: newId,
                    name: productName,
                    cp: '',
                    cpk: '',
                    timeFrame: {
                        timeType: 'daily',
                        value: new Date(),
                        component: <DatePicker
                            format="yyyy-MM-dd"
                            value={new Date()}
                            defaultOpen={true}
                        />
                    },
                    borderColor: borderColor,
                    total: 0,
                    pass: 0,
                    lsl: 0,
                    mean: 0,
                    usl: 0,
                    standardDeviation: 0,
                    passPercent: 0,
                    failPercent: 0,
                });
                break;
            }
            case 'Week': {
                newCardData.push({
                    id: newId,
                    name: productName,
                    cp: '',
                    cpk: '',
                    timeFrame: {
                        timeType: 'weekly',
                        value: [
                            new Date(new Date().setDate(new Date().getDate() - new Date().getDay())),
                            new Date(new Date().setDate(new Date().getDate() - new Date().getDay() + 6))
                        ],
                        component: <DateRangePicker
                            format="yyyy-MM-dd"
                            hoverRange="week"
                            placeholder="yyyy-MM-dd ~ yyyy-MM-dd"
                            style={{ width: '100%' }}
                            value={[
                                new Date(new Date().setDate(new Date().getDate() - new Date().getDay())),
                                new Date(new Date().setDate(new Date().getDate() - new Date().getDay() + 6))
                            ]}
                            defaultOpen={true}
                        />
                    },
                    borderColor: borderColor,
                    total: 0,
                    pass: 0,
                    lsl: 0,
                    mean: 0,
                    usl: 0,
                    standardDeviation: 0,
                    passPercent: 0,
                    failPercent: 0,
                });
                break;
            }
            case 'Month': {
                newCardData.push({
                    id: newId,
                    name: productName,
                    cp: '',
                    cpk: '',
                    timeFrame: {
                        timeType: 'monthly',
                        value: [
                            new Date(new Date().setDate(1)),
                            new Date(new Date().setMonth(new Date().getMonth() + 1, 0))
                        ],
                        component: <DateRangePicker
                            hoverRange="month"
                            value={[
                                new Date(new Date().setDate(1)),
                                new Date(new Date().setMonth(new Date().getMonth() + 1, 0))
                            ]}
                            defaultOpen={true}
                        />
                    },
                    borderColor: borderColor,
                    total: 0,
                    pass: 0,
                    lsl: 0,
                    mean: 0,
                    usl: 0,
                    standardDeviation: 0,
                    passPercent: 0,
                    failPercent: 0,
                });
                break;
            }
            case 'Year': {
                newCardData.push({
                    id: newId,
                    name: productName,
                    cp: '',
                    cpk: '',
                    timeFrame: {
                        timeType: 'yearly',
                        value: new Date(),
                        component: <DatePicker hoverRange="year"
                            value={new Date()}
                            defaultOpen={true}
                        />
                    },
                    borderColor: borderColor,
                    total: 0,
                    pass: 0,
                    lsl: 0,
                    mean: 0,
                    usl: 0,
                    standardDeviation: 0,
                    passPercent: 0,
                    failPercent: 0,
                });
                break;
            }
            case 'Custom': {
                newCardData.push({
                    id: newId,
                    name: productName,
                    cp: '',
                    cpk: '',
                    timeFrame: {
                        timeType: 'custom',
                        value: {
                            startDate: new Date(),
                            endDate: new Date()
                        },
                        component: <DateRangePicker
                            value={[
                                new Date(),
                                new Date()
                            ]}
                            defaultOpen={true}
                        />
                    },
                    borderColor: borderColor,
                    total: 0,
                    pass: 0,
                    lsl: 0,
                    mean: 0,
                    usl: 0,
                    standardDeviation: 0,
                    passPercent: 0,
                    failPercent: 0,
                });
                break;
            }
        }

        setCardData([...cardData, ...newCardData]);
        fetchStatisticalAnalysis(selectedProduct, [...cardData, ...newCardData]);
    };

    const handleDateChange = (id, value) => {
        const updatedCardData = cardData.map(item => {
            if (item.id === id) {
                return {
                    ...item,
                    timeFrame: {
                        ...item.timeFrame,
                        value: value,
                    }
                };
            }
            return item;
        });
        setCardData(updatedCardData);
        fetchStatisticalAnalysis(selectedProduct, updatedCardData);
    }

    const filteredProducts = products
        .filter((item) => parameterProducts.includes(item.id))
        .filter((product) => product.productName.toLowerCase().includes(searchQuery.toLowerCase()))
        .map((product) => ({
            id: product.id,
            productName: product.productName,
        }));


    const statisticalAnalysisCardData = async (metrics) => {
        if (!metrics) return;

        Object.entries(metrics).forEach(([key, value], index) => {
            setCardData(prevCardData =>
                prevCardData.map(card => {
                    if (Number(card.id) === Number(key)) {
                        return {
                            ...card,
                            cp: value?.cp ? (isNaN(Number(value.cp)) ? '-' : Number(value.cp).toFixed(2)) : '-',
                            cpk: value?.cpk ? (isNaN(Number(value.cpk)) ? '-' : Number(value.cpk).toFixed(2)) : '-',
                            total: value?.total || 0,
                            pass: value?.passed || 0,
                            lsl: value?.lowerLimit || 0,
                            mean: Number(value?.mean).toFixed(2) || 0,
                            usl: value?.upperLimit || 0,
                            standardDeviation: Number(value?.stddev).toFixed(2) || 0,
                            passPercent: value?.passpercent || 0,
                            failPercent: value?.failpercent || 0,
                            underWeight: value?.underweight || 0,
                            overWeight: value?.overweight || 0,
                        };
                    }
                    return card;
                })
            );
        });
    }

    const removeSelectedProduct = (id) => {
        setCardData((prev) => prev.filter((product) => product.id !== id)
        )
    }


    const addMoreProducts = () => {
        setShowProductSelection(true)
    }

    const statisticalGraphData = useMemo(() => {
        return {
            labels: lineData?.x ?? [],
            datasets: Object.keys(lineData?.y ?? {}).reduce(
                (acc, key, idx) => {
                    if (true) {
                        const data = lineData?.y?.[key] ?? [];
                        const card = cardData.find(card => Number(card.id) === Number(key));
                        const product = products.find((item) => item?.id === selectedProduct)?.productName;
                        acc.push({
                            label: product ?? '',
                            data,
                            fill: true,
                            borderColor: card?.borderColor || '#36A2EB',
                            backgroundColor: card?.borderColor ? `${card.borderColor}50` : 'rgba(54, 162, 235, 0.2)',
                            tension: 0.1,
                            key,
                        });
                    }
                    return acc;
                },
                []
            ),
        };

    }, [lineData])

    // for showing anaotation lsl and usl 
    const statisticalGraphAnnotations = useMemo(() => {
        const datasetLength = statisticalGraphData?.datasets?.length;
        let data = {};
        for (let i = 0; i < datasetLength; i++) {
            const key = statisticalGraphData?.datasets?.[i]?.key;
            const productMetrics = metricData?.[key] ?? {};
            const newData = {
                [`${i}l`]: {
                    type: 'line',
                    value: productMetrics?.lowerLimit ?? 0,
                    endValue: productMetrics?.lowerLimit ?? 0,
                    scaleID: 'x',
                    borderColor: 'red',
                    borderWidth: 4,
                    label: {
                        position: 'start',
                        content: `LSL: ${productMetrics?.lowerLimit ?? ''}`,
                        enabled: true,
                    },
                },
                [`${i}u`]: {
                    type: 'line',
                    value: productMetrics?.upperLimit ?? 0,
                    endValue: productMetrics?.upperLimit ?? 0,
                    scaleID: 'x',
                    borderColor: 'red',
                    borderWidth: 4,
                    label: {
                        position: 'start',
                        content: `USL: ${productMetrics?.upperLimit ?? ''}`,
                        enabled: true,
                    },
                },
            };
            data = {
                ...data, ...newData,
            };
        }
        return data;
    }, [statisticalGraphData, metricData]);

    const handleQualityValueChange = (value) => {
        // First update the local state
        setQualityValue(value);
        setSelectedProduct('');

        // Then update filters based on tab
        if (activeTab === 'statisticalAnalysis') {
            setStatisticalFilter({
                ...statisticalFilter,
                qualityParameterId: value?.id || null,
            });
            // Call API after filter update
            fetchParameterProductsStatisticalAnalysis(value?.id);
        } else {
            const failureAnalysisFilter = {
                ...FAILURE_ANALYSIS_FILTER,
                qualityParameterId: value?.id || null,
            };
            applyFilters({ FAILURE_ANALYSIS_FILTER: failureAnalysisFilter }, false);
        }
    };
    //FUNCTIONS-FUNCTIONS-FUNCTIONS-FUNCTIONS-FUNCTIONS

    const generateTimeFilters = () => {
        const updatedTimeFilters = [];
        const groupFilter = groupTypeFilter?.selection || {};

        updatedTimeFilters.push({
            type: 'brand',
            text: groupFilter?.brand?.label || brandsList?.[0]?.name,
            active: groupTypeFilter?.currentSelection === 'brand'
        });

        Object.keys(groupFilter).forEach((key) => {
            if (key !== 'brand') {
                updatedTimeFilters.push({
                    type: key,
                    text: groupFilter[key]?.label || key,
                    active: groupTypeFilter?.currentSelection === key
                });
            }
        });

        return updatedTimeFilters;
    };

    return (
        <div className='w-full h-full flex flex-col overflow-hidden'>
            <Tabs value={activeTab} onValueChange={handleTabChange} className='w-full h-full flex flex-col'>
                <TabsList className='w-full border-b border-b-orange-400 rounded-none bg-transparent h-auto p-0 justify-start shrink-0'>
                    <TabsTrigger
                        value='quality'
                        className={cn(
                            'rounded-none py-2 px-4 text-base font-medium border-b-2 transition-all duration-200 ease-in-out',
                            'data-[state=active]:border-orange-400 data-[state=active]:text-foreground data-[state=inactive]:border-transparent data-[state=inactive]:text-muted-foreground',
                            activeTab === 'quality' ? 'border-b-orange-400 font-bold text-black' : 'border-b-transparent',
                        )}
                    >
                        Quality Analysis
                    </TabsTrigger>
                    <TabsTrigger
                        value='failureAnalysis'
                        className={cn(
                            'rounded-none py-2 px-4 text-base font-medium border-b-2 transition-all duration-200 ease-in-out',
                            'data-[state=active]:border-orange-400 data-[state=active]:text-foreground data-[state=inactive]:border-transparent data-[state=inactive]:text-muted-foreground',
                            activeTab === 'failureAnalysis' ? 'border-b-orange-400 font-bold text-black' : 'border-b-transparent',
                        )}
                    >
                        Failure Analysis
                    </TabsTrigger>
                    <TabsTrigger
                        value='statisticalAnalysis'
                        className={cn(
                            'rounded-none py-2 px-4 text-base font-medium border-b-2 transition-all duration-200 ease-in-out',
                            'data-[state=active]:border-orange-400 data-[state=active]:text-foreground data-[state=inactive]:border-transparent data-[state=inactive]:text-muted-foreground',
                            activeTab === 'statisticalAnalysis' ? 'border-b-orange-400 font-bold text-black' : 'border-b-transparent',
                        )}
                    >
                        Statistical Analysis
                    </TabsTrigger>
                </TabsList>
            </Tabs>

            <AnimatePresence mode='wait'>
                {activeTab === 'quality' && (
                    <motion.div
                        key='quality'
                        initial='enter'
                        animate='center'
                        exit='exit'
                        variants={tabVariants}
                        transition={{
                            duration: 0.4,
                            ease: [0.43, 0.13, 0.23, 0.96]
                        }}
                        className='flex-1 p-0 h-[calc(100vh-8rem)] overflow-hidden'
                    >
                        <div className='h-full flex flex-col'>
                            <div className='flex flex-col md:flex-row justify-between items-start md:items-center gap-4 p-4 bg-white z-10 shrink-0'>
                                <ModernTabs tabs={QualityAnalysisTabs} activeSubTab={activeSubTab} handleSubTabChange={handleSubTabChange} />
                                <div className='flex flex-wrap divide-x border-none'>
                                    <ModernTabs tabs={groupTypeFilterList} activeSubTab={activeFilter} handleSubTabChange={handleFilterChange} />
                                    {/* <DateSwitcher 
                                        currentDate={currentDate} 
                                        handleDateChange={handleDateChange} 
                                        isCurrentDate={isCurrentDate} 
                                    /> */}
                                    <Button
                                        variant='outline'
                                        onClick={onFilterButtonClick}
                                        className='flex items-center gap-2 bg-[#0D9488] text-white hover:bg-[#0B7C73]'
                                    >
                                        <Filter className='h-4 w-4' />
                                        <span>Filter</span>
                                    </Button>
                                </div>
                            </div>

                            <div className='overflow-auto'>
                                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4'>
                                    {(boxData || []).map((key) => (
                                        <MetricCard key={key?.label || Math.random()} data={key} />
                                    ))}
                                </div>

                                {/* Chart Section */}
                                <div className='h-[calc(100vh-22rem)]  rounded-lg border border-gray-200'>
                                    <div className='h-full flex flex-col p-4'>
                                        <div className='h-full w-full'>
                                            <Bar
                                                data={chart}
                                                options={{
                                                    responsive: true,
                                                    maintainAspectRatio: false,
                                                    scales: {
                                                        x: {
                                                            stacked: true,
                                                            grid: {
                                                                display: false
                                                            }
                                                        },
                                                        y: {
                                                            stacked: true,
                                                            grid: {
                                                                display: true
                                                            }
                                                        }
                                                    },
                                                    plugins: {
                                                        datalabels: {
                                                            align: 'start',
                                                            padding: '0',
                                                            anchor: 'center',
                                                            maxRotation: 0,
                                                            rotation: 270,
                                                            // formatter: dataLabelFormatter,
                                                            // display: showDataLabels,
                                                            clamp: false,
                                                            color: '#000',
                                                            font: {
                                                                weight: '400',
                                                                size: 9,
                                                            },
                                                        },
                                                        title: {
                                                            display: true,
                                                            text: 'Food Quality Performance',
                                                            font: {
                                                                color: 'black',
                                                                size: 16,
                                                            },
                                                        },
                                                    },
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='w-full bg-white border-t'>
                            {groupTypeFilter?.type === 'periodWise' ? (
                                <TimeFilter
                                    timeFilters={timeFilters}
                                    onClick={handleTimeFilter}
                                    graphYear={new Date().getFullYear()}
                                />
                            ) : (
                                <TimeFilter
                                    timeFilters={generateTimeFilters()}
                                    onClick={handleTypeFilter}
                                />
                            )}
                        </div>
                    </motion.div>
                )}

                {activeTab === 'failureAnalysis' && (
                    <motion.div
                        key='failure'
                        initial='enter'
                        animate='center'
                        exit='exit'
                        variants={tabVariants}
                        transition={{
                            duration: 0.4,
                            ease: [0.43, 0.13, 0.23, 0.96]
                        }}
                        className='flex-1 h-[calc(100vh-8rem)] overflow-hidden'
                    >
                        <div className='h-full flex flex-col'>
                            {/* Header Section */}
                            <div className='flex flex-col md:flex-row justify-between items-start md:items-center gap-4 p-4 bg-white z-10 shrink-0'>
                                <div className='relative w-full md:w-auto'>
                                    <div className='flex items-center gap-2'>
                                        <span className='text-sm font-medium'>Select Failure Parameter</span>
                                        <div className='relative w-[300px]'>
                                            <ParameterSelector
                                                parameters={parameters}
                                                handleQualityValueChange={handleQualityValueChange}
                                                qualityValue={qualityValue}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className='flex flex-wrap divide-x border-none'>
                                    <ModernTabs tabs={groupTypeFilterList} activeSubTab={activeFilter} handleSubTabChange={handleFilterChange} />


                                    <DateSwitcher
                                        currentDate={currentDate}
                                        handleDateChange={handleDateChange}
                                        isCurrentDate={isCurrentDate}
                                    />
                                    <Button
                                        variant='outline'
                                        onClick={onFilterButtonClick}
                                        className='flex items-center gap-2 bg-[#0D9488] text-white hover:bg-[#0B7C73]'
                                    >
                                        <Filter className='h-4 w-4' />
                                        <span>Filter</span>
                                    </Button>
                                </div>
                            </div>

                            <div className='overflow-auto'>
                                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4'>
                                    {(boxData || []).map((key) => (
                                        <MetricCard key={key?.label || Math.random()} data={key} />
                                    ))}
                                </div>

                                <div className='h-[calc(100vh-22rem)]  rounded-lg border border-gray-200 flex flex-col justify-between border border-gray-200'>
                                    <div className='h-full flex flex-col p-4'>
                                        <div className='h-full w-full '>
                                            <Bar
                                                data={chart}
                                                options={{
                                                    responsive: true,
                                                    maintainAspectRatio: false,
                                                    scales: {
                                                        x: {
                                                            stacked: true,
                                                            grid: {
                                                                display: false
                                                            }
                                                        },
                                                        y: {
                                                            stacked: true,
                                                            grid: {
                                                                display: true
                                                            }
                                                        }
                                                    },
                                                    plugins: {
                                                        datalabels: {
                                                            align: 'start',
                                                            padding: '0',
                                                            anchor: 'center',
                                                            maxRotation: 0,
                                                            rotation: 270,
                                                            // formatter: dataLabelFormatter,
                                                            // display: showDataLabels,
                                                            clamp: false,
                                                            color: '#000',
                                                            font: {
                                                                weight: '400',
                                                                size: 9,
                                                            },
                                                        },
                                                        title: {
                                                            display: true,
                                                            text: 'Food Quality Performance',
                                                            font: {
                                                                color: 'black',
                                                                size: 16,
                                                            },
                                                        },
                                                    },
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='w-full bg-white border-t'>
                            {groupTypeFilter?.type === 'periodWise' ? (
                                <TimeFilter
                                    timeFilters={timeFilters}
                                    onClick={handleTimeFilter}
                                    graphYear={new Date().getFullYear()}
                                />
                            ) : (
                                <TimeFilter
                                    timeFilters={generateTimeFilters()}
                                    onClick={handleTypeFilter}
                                />
                            )}
                        </div>
                    </motion.div>
                )}

                {activeTab === 'statisticalAnalysis' && (
                    <StatisticalChart
                        activeTab={activeTab}
                        parameters={parameters}
                        handleQualityValueChange={handleQualityValueChange}
                        qualityValue={qualityValue}
                        onFilterButtonClick={onFilterButtonClick}
                        cardData={cardData}
                        removeSelectedProduct={removeSelectedProduct}
                        filteredProducts={filteredProducts}
                        selectedProduct={selectedProduct}
                        statsBoxData={statsBoxData}
                        statisticalGraphData={statisticalGraphData}
                        statisticalGraphAnnotations={statisticalGraphAnnotations}
                        tabVariants={tabVariants}
                        fadeVariants={fadeVariants}
                        // new props
                        timeFrame={timeFrame}
                        setCardData={setCardData}
                        timeFrameList={timeFrameList}
                        handleProductSelection={handleProductSelection}
                        setTimeFrame={setTimeFrame}
                        handleAddTimeFrame={handleAddTimeFrame}
                        isCollapsed={isCollapsed}
                        setIsCollapsed={setIsCollapsed}
                        isLoading={isLoading}
                        handleDateChange={handleDateChange}
                    />
                )}
            </AnimatePresence>
        </div>
    )
}
const mapStateToProps = (state) => {
    const { LIST: brandsList } = state?.form?.BRANDS?.data ?? {}
    const products = state.form.ALL_PRODUCTS.data.LIST;
    const { STATISTICAL_FILTER, DATE_FILTER_TODAY_DATE, DATE_RANGE_FILTER, GEO_FILTER, BRAND_FILTER, STORE_FILTER, FAILURE_ANALYSIS_FILTER, PRODUCT_FILTER } = state?.analytics;
    return {
        brandsList,
        DATE_FILTER_TODAY_DATE,
        DATE_RANGE_FILTER,
        GEO_FILTER,
        BRAND_FILTER,
        STORE_FILTER,
        FAILURE_ANALYSIS_FILTER,
        PRODUCT_FILTER,
        STATISTICAL_FILTER,
        products,
    };
};

export default connect(mapStateToProps, {
    // setGroupTypeFilter: analyticsAction.setTypeFilter,
    setDateFilter: analyticsAction.setDateFilterTodayDate,
    setDateRangeFilter: analyticsAction.setDateRangeFilter,
    applyFilters: analyticsAction.applyFilters,
    fetchBrands: formActions.gateway,
    fetchProducts: formActions.gateway,
})(QualityAnalysisDashboard);



